import React, { useEffect } from 'react';
import Head from 'next/head';
import { NextPageContext } from 'next/types';

import {
  setInverted,
  setProtected,
  unsetInverted,
  unsetProtected,
} from 'src/actions/app';
import useConfig from 'src/common/hooks/useConfig';
import { MetadataRenderer } from 'src/components/MetaDescription/MetadataRenderer';

import { GoogleLogoSchema } from '../Components/GoogleLogoSchema';
import { AudienceCards } from './Components/AudienceCards';
import { Hero } from './Components/Hero';
import { OneGlints } from './Components/OneGlints';
import { Stats } from './Components/Stats';
import { TrustStrip } from './Components/TrustStrip';
import { LandingRoot, SGGlobalStyle } from './LandingTalentHub.sc';

interface LandingTalentHubProps {
  [key: string]: unknown;
}

const LandingTalentHub = (_props: LandingTalentHubProps) => {
  const config = useConfig();

  useEffect(() => {
    setInverted();
    unsetProtected();
    return () => {
      unsetInverted();
      setProtected();
    };
  }, []);

  const candidateBase = config.CANDIDATE_BASE;

  return (
    <LandingRoot className="landing-component">
      <SGGlobalStyle />
      <MetadataRenderer
        isLandingPage={true}
        glintsTrackingName="landing_page_talenthub"
      />
      <Head>
        <link rel="alternate" hrefLang="x-default" href={candidateBase} />
        <link rel="alternate" hrefLang="en-sg" href={`${candidateBase}/sg`} />
        <link rel="alternate" hrefLang="id-id" href={`${candidateBase}/id`} />
        <link
          rel="alternate"
          hrefLang="en-id"
          href={`${candidateBase}/id/en`}
        />
        <link rel="alternate" hrefLang="en-my" href={`${candidateBase}/my`} />
        <link rel="alternate" hrefLang="vi-vn" href={`${candidateBase}/vn`} />
        <link
          rel="alternate"
          hrefLang="en-vn"
          href={`${candidateBase}/vn/en`}
        />
      </Head>
      <GoogleLogoSchema />

      <Hero />

      <AudienceCards />

      <Stats />

      <TrustStrip />

      <OneGlints />
    </LandingRoot>
  );
};

LandingTalentHub.getInitialProps = async (_context: NextPageContext) => {
  return {};
};

export default LandingTalentHub;
